import React from 'react';
import {
  createTheme,
  lightTheme,
  genPageTheme,
  shapes
} from '@backstage/theme';

import { AppTheme } from '@backstage/core-plugin-api';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import LightIcon from '@material-ui/icons/WbSunny';

const cobliLightPalette = {
  ...lightTheme.palette,
  primary: {
    main: '#001BB8',
  },
  secondary: {
    main: '#07074E',
  },
  error: {
    main: '#07074E',
  },
  warning: {
    main: '#07074E',
  },
  info: {
    main: '#001BB8',
  },
  success: {
    main: '#07074E',
  },
  background: {
    default: '#F6F6F6',
    paper: '#ffffff',
  },
  banner: {
    info: '#07074E',
    error: '#07074E',
    text: '#07074E',
    link: '#07074E',
  },
  errorBackground: '#123456',
  warningBackground: '#123456',
  infoBackground: '#123456',
  navigation: {
    background: '#07074E',
    indicator: '#ffffff',
    color: '#DCDCDC',
    selectedColor: '#ffffff',
  },
}


export const appLightTheme = createTheme({
  palette: cobliLightPalette,
  fontFamily: 'Roboto,Arial,sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.round }),
    service: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    website: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#001BB8', '#07074E'], shape: shapes.wave }),
  },
});


export const cobliLightTheme: Partial<AppTheme> & Omit<AppTheme, "theme"> = {
  id: 'cobli-light-theme',
  title: 'Cobli Custom Light Theme',
  variant: 'light',
  icon: <LightIcon />,
  Provider: ({ children }: { children: any }) => (
    <ThemeProvider theme={appLightTheme}>
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  ),
};
